<template>
  <div v-if="isVisible" class="popup-overlay" @click.self="closePopup">
    <div class="popup-container">
      <!-- 헤더 -->
      <div class="popup-header">
        <span class="header-label">REGISTRATION</span>
        <h3>관심고객 등록</h3>
        <p class="header-desc">지금 등록하시면 특별 혜택을 드립니다</p>
      </div>

      <!-- 폼 -->
      <form @submit.prevent="submitForm" class="registration-form">
        <div class="form-group">
          <input
            type="text"
            v-model="form.name"
            placeholder="성함"
            required
            :disabled="isSubmitting"
          />
        </div>

        <div class="form-group">
          <PhoneInput v-model="form.phone" :disabled="isSubmitting" required />
        </div>

        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              v-model="form.agreePrivacy"
              required
              :disabled="isSubmitting"
            />
            <span class="checkmark"></span>
            <span class="checkbox-text">
              개인정보 수집 및 이용 동의
              <button type="button" class="privacy-link" @click="showPrivacy = true">보기</button>
            </span>
          </label>
        </div>

        <button type="submit" class="submit-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '등록 중...' : '관심고객 등록하기' }}
        </button>
      </form>

      <!-- 하단 버튼들 -->
      <div class="popup-actions">
        <button class="action-btn" @click="hideFor24Hours">
          24시간 동안 보지 않기
        </button>
        <button class="action-btn close" @click="closePopup">
          닫기
        </button>
      </div>

      <!-- 개인정보처리방침 모달 -->
      <div v-if="showPrivacy" class="privacy-overlay" @click.self="showPrivacy = false">
        <div class="privacy-modal">
          <h4>개인정보 수집 및 이용 동의</h4>
          <div class="privacy-content">
            <p><strong>수집 항목</strong><br>성함, 연락처</p>
            <p><strong>수집 목적</strong><br>관심고객 등록 및 분양 안내</p>
            <p><strong>보유 기간</strong><br>목적 달성 후 즉시 파기</p>
          </div>
          <button @click="showPrivacy = false" class="privacy-close">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveConsultation } from '@/firebase/consultationService'
import PhoneInput from '@/components/common/PhoneInput.vue'

export default {
  name: 'RegistrationPopup',
  components: { PhoneInput },
  data() {
    return {
      isVisible: false,
      showPrivacy: false,
      isSubmitting: false,
      form: {
        name: '',
        phone: '',
        agreePrivacy: false
      }
    }
  },
  mounted() {
    this.checkVisibility()
  },
  methods: {
    checkVisibility() {
      const hideUntil = localStorage.getItem('registrationPopupHideUntil')
      if (hideUntil) {
        const hideUntilTime = parseInt(hideUntil, 10)
        if (Date.now() < hideUntilTime) {
          this.isVisible = false
          return
        }
      }
      this.isVisible = true
    },
    closePopup() {
      this.isVisible = false
    },
    hideFor24Hours() {
      const hideUntil = Date.now() + (24 * 60 * 60 * 1000)
      localStorage.setItem('registrationPopupHideUntil', hideUntil.toString())
      this.isVisible = false
    },
    async submitForm() {
      if (!this.form.agreePrivacy) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        const result = await saveConsultation({
          name: this.form.name,
          phone: this.form.phone
        }, 'registration-popup')

        if (result.success) {
          alert('관심고객 등록이 완료되었습니다.')
          this.form = { name: '', phone: '', agreePrivacy: false }
          this.closePopup()
        } else {
          alert('오류가 발생했습니다. 다시 시도해주세요.')
        }
      } catch (error) {
        console.error('Submit error:', error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 10001;
}

.popup-container {
  background: #fff;
  overflow: hidden;
  max-width: 380px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: popupIn 0.3s ease;
}

@keyframes popupIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* 헤더 */
.popup-header {
  padding: 28px 24px;
  text-align: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
}

.header-label {
  display: block;
  font-size: 11px;
  letter-spacing: 3px;
  color: #D4AF37;
  margin-bottom: 10px;
}

.popup-header h3 {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.header-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

/* 폼 */
.registration-form {
  padding: 24px;
}

.form-group {
  margin-bottom: 14px;
}

.form-group input[type="text"],
.form-group input[type="tel"] {
  width: 100%;
  padding: 16px;
  border: 1px solid #e0e0e0;
  font-size: 15px;
  font-family: inherit;
  background: #fafafa;
  transition: all 0.2s;
}

.form-group input::placeholder {
  color: #aaa;
}

.form-group input:focus {
  outline: none;
  border-color: #333;
  background: #fff;
}

.form-group input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

.form-group :deep(.phone-segment) {
  padding: 16px 6px;
  border: 1px solid #e0e0e0;
  font-size: 15px;
  background: #fafafa;
  transition: all 0.2s;
}

.form-group :deep(.phone-segment:focus) {
  outline: none;
  border-color: #333;
  background: #fff;
}

.form-group :deep(.phone-segment:disabled) {
  background: #f5f5f5;
  cursor: not-allowed;
}

/* 체크박스 */
.checkbox-group {
  margin-top: 16px;
  margin-bottom: 20px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  color: #666;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: 1.5px solid #ccc;
  position: relative;
  transition: all 0.2s;
}

.checkbox-label input:checked + .checkmark {
  background: #222;
  border-color: #222;
}

.checkbox-label input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-text {
  display: flex;
  align-items: center;
  gap: 6px;
}

.privacy-link {
  background: none;
  border: none;
  color: #D4AF37;
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
  padding: 0;
}

/* 제출 버튼 */
.submit-btn {
  width: 100%;
  padding: 18px;
  background: #222;
  color: #fff;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn:hover:not(:disabled) {
  background: #333;
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 하단 버튼들 */
.popup-actions {
  display: flex;
  border-top: 1px solid #e5e5e5;
}

.action-btn {
  flex: 1;
  padding: 14px;
  background: #f8f8f8;
  border: none;
  font-size: 13px;
  color: #888;
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:first-child {
  border-right: 1px solid #e5e5e5;
}

.action-btn:hover {
  background: #eee;
  color: #555;
}

.action-btn.close {
  font-weight: 600;
  color: #666;
}

/* 개인정보 모달 */
.privacy-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 10002;
}

.privacy-modal {
  background: #fff;
  padding: 24px;
  max-width: 300px;
  width: 100%;
}

.privacy-modal h4 {
  font-size: 15px;
  margin-bottom: 16px;
  color: #222;
  font-weight: 600;
}

.privacy-content p {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 12px;
}

.privacy-content p strong {
  color: #333;
  font-weight: 600;
}

.privacy-close {
  width: 100%;
  padding: 12px;
  background: #222;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
}

/* 반응형 */
@media (max-width: 480px) {
  .popup-container {
    max-width: 320px;
  }

  .popup-header {
    padding: 24px 20px;
  }

  .popup-header h3 {
    font-size: 20px;
  }

  .registration-form {
    padding: 20px;
  }

  .form-group input[type="text"],
  .form-group input[type="tel"] {
    padding: 14px;
    font-size: 14px;
  }

  .form-group :deep(.phone-segment) {
    padding: 14px 4px;
    font-size: 14px;
  }

  .submit-btn {
    padding: 16px;
    font-size: 15px;
  }

  .action-btn {
    padding: 12px;
    font-size: 12px;
  }
}
</style>
